// 推荐需求模块
<template>
  <div>
    <div class="card-group-top vertical-flex-box">
      <span class="font-normal font-bold">推荐项目</span>
    </div>
    <div class="card-group-foot bottom-margin">
      <ul class="ul-no-dot">
        <li v-for="(item, index) in recommendRequirementList" :key="index" @click="toDetail(item.id)">
          <!--<span v-if="item.settlementType == 0"-->
                <!--class="font-red font-small left-span">￥{{item.amount | amountFormatter}}/单</span>&nbsp;&nbsp;-->
          <!--<span v-else class="font-red font-small left-span">￥{{item.amount | amountFormatter}}</span>-->
          <span class="font-small">{{item.name | textFormatter}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {getRecommendRequirementList} from "@/api/requirement/requirement"

  export default {
    name: "recommend",
    data() {
      return {
        recommendRequirementList: []
      }
    },
    mounted() {
      this.getRecommendRequirementList()
    },
    computed: {},
    filters: {
      textFormatter(value) {
        if (!value) return ''
        if (value.toString().length > 10) return value.substring(0, 9) + '...'
        return value
      },
      amountFormatter(value) {
        if (!value) return ''
        return (value * 1).toFixed(2)
      }
    },
    methods: {
      getRecommendRequirementList() {
        getRecommendRequirementList().then(res => {
          if (res.data.code == 0) {
            this.recommendRequirementList = res.data.data
          } else {
            this.$message.error("获取数据失败")
          }
        })
      },
      toDetail(reqId) {
        this.$router.push({path: "/reqdetail/:id", name: 'requirementDetail', params: {id: reqId}})
      },
    }
  }
</script>

<style>
  @import "../../assets/css/common.css";

  .left-span {
    padding-right: 10px;
  }
</style>
